export interface FlashHotelPackageDisplayedPricing {
  memberPrice?: number
  nonMemberPrice: number
  value: number
}

interface Options {
  loading: boolean
  charterPrice?: number
  charterMemberPrice?: number
  charterValue?: number
  flightPricing?: App.PricingWithValue
  flightMemberPricing?: App.PricingWithValue
  hotelPricing: App.PricingWithValue
  hotelMemberPricing?: App.PricingWithValue
  convertToDisplay: (price: number) => number
}

/**
 * Resolves the same charter, flight or hotel price branch selected by the package price component.
 * The event cannot safely read the package's base totals because flight and charter prices arrive
 * asynchronously and may replace them. Keeping this resolver pure lets the rendering owner report
 * only its settled branch without duplicating that decision inside the impression hook.
 */
export default function getFlashHotelPackageDisplayedPricing({
  loading,
  charterPrice,
  charterMemberPrice,
  charterValue,
  flightPricing,
  flightMemberPricing,
  hotelPricing,
  hotelMemberPricing,
  convertToDisplay,
}: Options): FlashHotelPackageDisplayedPricing | undefined {
  if (loading) return

  if (charterPrice !== undefined) {
    return {
      nonMemberPrice: charterPrice,
      memberPrice: charterMemberPrice,
      value: charterValue ?? charterPrice,
    }
  }

  if (flightPricing) {
    return {
      nonMemberPrice: convertToDisplay(flightPricing.price),
      memberPrice: flightMemberPricing?.price ? convertToDisplay(flightMemberPricing.price) : undefined,
      value: convertToDisplay(flightPricing.value),
    }
  }

  return {
    nonMemberPrice: convertToDisplay(hotelPricing.price),
    memberPrice: hotelMemberPricing?.price ? convertToDisplay(hotelMemberPricing.price) : undefined,
    value: convertToDisplay(hotelPricing.value),
  }
}
